/**
 * The world's address and phone rules (`@libs/utils/world`), as every
 * platform-wire user reads them (LIS-1173): its own subpath, never the
 * package root, so an importer that needs no world data (Admin, Lissen for
 * Partners) never bundles `countries.json`.
 */
export * from "@libs/utils/world";
